import { MARQUEE_WORDS } from "../content";

export default function Marquee() {
  const words = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div className="overflow-hidden border-y border-[#EAE6F0] bg-white py-4" aria-hidden="true">
      <div className="marquee-track">
        {words.map((word, i) => (
          <span
            key={i}
            className="flex items-center whitespace-nowrap text-lg font-bold uppercase tracking-[0.2em] text-[#242344]/30"
          >
            <span className="px-6">{word}</span>
            <span className="text-[#FF008B]/50">✳</span>
          </span>
        ))}
      </div>
    </div>
  );
}
